<template>
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.369141 0.337891L5.86891 6.33789L11.3691 0.337891" stroke="#242653"/>
    </svg>
</template>